export const sendFBEvent = (event, params) => {
  if (typeof window === "undefined") return;

  const fbq = window.fbq;

  if (!fbq) return;

  if (params) {
    fbq("track", event, params);
  } else {
    fbq("track", event);
  }
};
